// extracted by mini-css-extract-plugin
export default {"huiContainer":"styles_huiContainer__wNog-","content":"styles_content__RaLhu"};